import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import { TurnoverSearchFields } from "../../../utils/constants/userMenuFilterInputs.constants copy";
import UserMenuPageTitle from "../shared/user-menu/UserMenuPageTitle";
import DepositTurnoverFilter from "./DepositTurnoverFilter";
import { SVLS_API_CLIENT } from "../../../App.utils";
import {
  CURRENCY_TYPE_FACTOR,
  getCurrencyTypeFromToken,
  getOutcomeDescByEnumName,
} from "@hypexone/uicore";
import TableComponent from "../shared/TableComponent";
import { depositTurnoverTableColumns } from "../../../utils/constants/userMenuTableColumns.constants";

interface DepositTurnoverViewProps { }
type Filters = {
  dateFrom: any;
  dateTo: any;
  pageToken: string[];
  status: string;
};
type DepositTurnoverDTO = {
  id: number;
  account_id: number;
  user_name: string;
  deposit_amount: number;
  cashable_amount: number;
  turnover_required: number;
  turnover_met: number;
  turnover_percentage: number;
  transaction_id: string;
  pg_transaction_id: string;
  status: string;
  notes: string;
  award_date: number;
  redeem_date: number;
  update_time: number;
};
const DepositTurnover: React.FC = (props) => {
  const defaultFilters: Filters = {
    dateFrom: moment().subtract(7, "d"),
    dateTo: moment(),
    pageToken: [],
    status: "AWARDED",
  };
  const [filters, setFilters] = useState<Filters>(defaultFilters);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);
  const pageSize = 25;
  const [nextPageToken, setNextPageToken] = useState<string>(null);
  const [turnover, setTurnover] = useState<DepositTurnoverDTO[]>([]);
  const [TransactionType, setTransactionType] = useState("");
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const [updatedRecords, setUpdatedRecords] = useState([]);

  const nextPage = () => {
    if (nextPageToken) {
      setFilters({
        ...filters,
        pageToken: [...filters.pageToken, nextPageToken],
      });
      setNextPageToken(null);
    }
  };

  const prevPage = () => {
    if (filters.pageToken?.length > 0) {
      let pagetokens = filters.pageToken;
      pagetokens.pop();
      setFilters({
        ...filters,
        pageToken: [...pagetokens],
      });
      setNextPageToken(null);
    }
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const claims = sessionStorage.getItem("jwt_token").split(".")[1];
      const username = JSON.parse(window.atob(claims)).sub;
      const accountId = JSON.parse(window.atob(claims)).aid;
      const response = await SVLS_API_CLIENT.get("wallet/v2/deposit-turnover", {
        headers: {
          Authorization: sessionStorage.getItem("jwt_token"),
          Accept: "application/json",
        },
        params: {
          pageSize: pageSize,
          pageToken: filters.pageToken[filters.pageToken.length - 1],
          startDate: filters.dateFrom.startOf("day").toISOString(),
          endDate: filters.dateTo.endOf("day").toISOString(),
          accountId: accountId,
          status: filters.status === "ALL" ? null : filters.status,
        },
      });
      const depositTurnoverEntries = response.data?.entries ?? [];
      for (const entry of depositTurnoverEntries) {
          entry.deposit_amount = entry.deposit_amount ? entry.deposit_amount / cFactor : 0;
          entry.cashable_amount = entry.cashable_amount ? entry.cashable_amount / cFactor : 0;
          entry.turnover_required = entry.turnover_required ? entry.turnover_required / cFactor : 0;
          entry.turnover_met = entry.turnover_met ? entry.turnover_met / cFactor : 0;
      }
      setNextPageToken(response.data?.nextPageToken);
      setTurnover(depositTurnoverEntries);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, [cFactor, filters]);

  const handleSearchSubmit = () => { };
  const handleDateChange = () => { };
  useEffect(() => {
    const array = turnover?.map((data: any) => {
      return {
        Transaction_Time: moment(data?.startTime).format("DD-MM-YY, h:mm:ss A"),
        Amount: data?.amount.toFixed(2),
        cashable_amount: data?.amount.toFixed(2),
         turnover: `${data.turnover_met || "-"} / ${
          data.turnover_required || "-"
        }`,
         status: getOutcomeDescByEnumName(data.outcomeResult.toString())
                  ? getOutcomeDescByEnumName(data.outcomeResult.toString())
                  : "Unsettled",
        installments: `${data.installments_given || "-"} / ${data.installments || "-"
          }`,
          redeem_date: data.redeem_date,
        update_time: moment(data?.update_time).format("DD-MM-YY, h:mm:ss A")
      };
    });
    setUpdatedRecords(array);
  }, [turnover]);



  return (
    <>

      <div className="font-robotoCondensed border">
        <div className="p-1">
          <DepositTurnoverFilter
            fields={TurnoverSearchFields}
            onSubmit={handleSearchSubmit}
            onDateChange={handleDateChange}
            filters={filters}
            setFilters={setFilters}
            setTransactionType={setTransactionType}
            TransactionType={TransactionType}
          />
        </div>
        <div className="p-1">
          <UserMenuPageTitle title="Deposit Turnover" />
        </div>
        <TableComponent
          reports={""}
          pageToken={nextPageToken}
          columns={depositTurnoverTableColumns}
          setFilters={setFilters}
          filters={filters}
          records={updatedRecords}
        />
        {/* <div className="flex flex-col items-center">
          <div className="overflow-x-auto p-2 w-full text-[12px]">
            <table className="min-w-full border-separate border-spacing-0">
              <thead>
                <tr>
                  {Object.values(tableHeaders).map((column, index) => (
                    <th
                      key={index}
                      className="border bg-blue3 text-white lg:text-black lg:bg-white border-gray-300 p-2"
                    >
                      {column}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="w-full">
                {turnover?.length > 0 ? (
                  <>
                    {turnover.map((row, idx) => (
                      <tr key={"row-" + idx}>
                        <td className="border border-gray-300 p-2">
                          <div className="b-text m-link">
                            {moment(row.award_date).format(
                              "DD/MM/YYYY, h:mm:ss A"
                            )}
                          </div>
                        </td>
                        <td className="border border-gray-300 p-2">
                          {row?.deposit_amount?.toFixed(2)}
                        </td>
                        <td className="border border-gray-300 p-2">
                          {row?.cashable_amount?.toFixed(2)}
                        </td>
                        <td
                          align="center"
                          className="border border-gray-300 p-2"
                        >
                          {(row.turnover_met ? row.turnover_met : "-") +
                            "/" +
                            (row.turnover_required
                              ? row.turnover_required
                              : "-")}
                        </td>
                        <td
                          align="center"
                          className="border border-gray-300 p-2"
                        >
                          {row.status}
                        </td>
                        <td className="border border-gray-300 p-2">
                          {row.redeem_date
                            ? moment(row.redeem_date).format(
                                "DD/MM/YYYY, h:mm:ss A"
                              )
                            : "-"}
                        </td>
                        <td>
                          {row.update_time
                            ? moment(row.update_time).format(
                                "DD/MM/YYYY, h:mm:ss A"
                              )
                            : "-"}
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr>
                    <td className="p-2 flex " colSpan={12}>
                      <div>{langData?.['no_data_found']}</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="w-full flex justify-center">
          <div className="flex items-center justify-center space-x-4 border rounded-lg p-2">
            <Button
              onClick={prevPage}
              className="px-3 py-1 text-gray-500 hover:text-gray-700 focus:outline-none"
              disabled={filters?.pageToken.length <= 0}
            >
              « Previous({filters.pageToken.length})
            </button>
            <button
              onClick={nextPage}
              className="px-3 py-1 text-gray-500 hover:text-gray-700 focus:outline-none"
              disabled={filters.pageToken == null}
            >
              {langData?.['next']}({filters.pageToken.length + 2}) »
            </Button>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default DepositTurnover;
